const iranMobileRegex = /^{?(09[0-9]{9,9}}?)$/;
const afghanistanMobileRegex = /^937[0-9]{0,11}$|7[0-9]{0,9}$/;
const iraqMobileRegex = /^(((?:\+|00)964)|(0)*)7\d{9}$/;

const mobileRegex = {
  iran: iranMobileRegex,
  iraq: iraqMobileRegex,
  afghanistan: afghanistanMobileRegex,
};

const persianCharactersRegex =
  /([آابپتثجچحخدذرزژسشصضطظعغفقکگلمنوهی۱۲۳۴۵۶۷۸۹])/g;

const numberRegex = /^([۰-۹0-9])*$/;

const englishNumberRegex = /^([0-9])*$/;

const englishCharactersRegex = /[A-Za-z][A-Za-z0-9]/;

const passwordRegex =
  /((?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])|(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%&/=?_.,:;\\-])|(?=.*[a-z])(?=.*[0-9])(?=.*[!@#$%&/=?_.,:;\\-])|(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%&/=?_.,:;\\-])).{8,}/;

const emailRegex =
  /(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))/;

const shebaNumberRegex = /^[0-9]{24}$/;

const postalCodeRegex =
  /^(?!.*(0|1|2|3|4|5|6|7|8|9)\1{9})(?!.*(0|2).{5})\d{10}$/;

const urlRegex = new RegExp(
  // eslint-disable-next-line no-useless-escape
  /(\b(https?|ftp|file):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/gi
);

const passportCodeRegex = /(?!^0+$)[a-zA-Z0-9]{3,20}/;

const isValidIranianNationalCode = (input: string): boolean => {
  if (!/^\d{10}$/.test(input)) {
    return false;
  }
  const check = Number(input[9]);
  const sum =
    input
      .split('')
      .slice(0, 9)
      .reduce((acc, x, i) => acc + Number(x) * (10 - i), 0) % 11;
  return sum < 2 ? check === sum : check + sum === 11;
};

export {
  afghanistanMobileRegex,
  emailRegex,
  englishCharactersRegex,
  englishNumberRegex,
  iranMobileRegex,
  iraqMobileRegex,
  isValidIranianNationalCode,
  mobileRegex,
  numberRegex,
  passportCodeRegex,
  passwordRegex,
  persianCharactersRegex,
  postalCodeRegex,
  shebaNumberRegex,
  urlRegex,
};
